import { render, staticRenderFns } from "./DataBind.vue?vue&type=template&id=0b69f9f9&scoped=true"
import script from "./DataBind.vue?vue&type=script&lang=js"
export * from "./DataBind.vue?vue&type=script&lang=js"
import style0 from "./DataBind.vue?vue&type=style&index=0&id=0b69f9f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b69f9f9",
  null
  
)

export default component.exports